var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    viewBox: "0 0 12 100",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V37.8049L11 50L1 62.1951V100",
    stroke: "currentcolor",
    vectorEffect: "non-scaling-stroke"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsArrow);
export default "data:image/svg+xml;base64,PHN2ZwogIHdpZHRoPSIxMiIKICB2aWV3Qm94PSIwIDAgMTIgMTAwIgogIGZpbGw9Im5vbmUiCiAgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCj4KICA8cGF0aAogICAgZD0iTTEgMFYzNy44MDQ5TDExIDUwTDEgNjIuMTk1MVYxMDAiCiAgICBzdHJva2U9ImN1cnJlbnRjb2xvciIKICAgIHZlY3RvckVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIgogIC8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };